(function () {
  'use strict';

  var PRODUCT_BUTTON_SELECTOR = '#atc-btn[data-variant-id]';
  var PRODUCT_QUANTITY_SELECTOR = '[data-wc-pdp-quantity-input]';
  var CART_QUANTITY_SELECTOR = 'cart-quantity-selector-component input[type="number"]';
  var dynamicFixTimer = null;

  function storeRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function clampQuantity(value, minimum) {
    var parsed = parseInt(value, 10);
    var min = Number.isFinite(minimum) ? minimum : 1;
    if (!Number.isFinite(parsed)) return min;
    return Math.max(min, Math.min(parsed, 99));
  }

  function emit(eventName, parameters) {
    if (
      window.WeathercraftPhase2Analytics &&
      typeof window.WeathercraftPhase2Analytics.emit === 'function'
    ) {
      window.WeathercraftPhase2Analytics.emit(eventName, parameters || {});
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, parameters || {}));
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function ensureProductPurchaseControls() {
    var button = document.querySelector(PRODUCT_BUTTON_SELECTOR);
    if (!button) return;

    var actions = button.closest('.pdp-hero__actions');
    if (!actions || actions.querySelector('[data-wc-pdp-quantity]')) return;

    actions.classList.add('wc-has-quantity');

    var group = createElement('div', 'wc-pdp-quantity');
    group.dataset.wcPdpQuantity = 'true';

    var label = createElement('label', 'wc-pdp-quantity__label', 'Bottle quantity');
    var inputId = 'wc-pdp-quantity-' + String(button.dataset.variantId || 'wine');
    label.setAttribute('for', inputId);

    var controls = createElement('div', 'wc-pdp-quantity__controls');

    var minus = createElement('button', 'wc-pdp-quantity__button', '−');
    minus.type = 'button';
    minus.dataset.wcPdpQuantityAction = 'decrease';
    minus.setAttribute('aria-label', 'Decrease bottle quantity');

    var input = createElement('input', 'wc-pdp-quantity__input');
    input.id = inputId;
    input.type = 'number';
    input.min = '1';
    input.max = '99';
    input.step = '1';
    input.value = '1';
    input.inputMode = 'numeric';
    input.setAttribute('enterkeyhint', 'done');
    input.dataset.wcPdpQuantityInput = 'true';
    input.setAttribute('aria-label', 'Bottle quantity');

    var plus = createElement('button', 'wc-pdp-quantity__button', '+');
    plus.type = 'button';
    plus.dataset.wcPdpQuantityAction = 'increase';
    plus.setAttribute('aria-label', 'Increase bottle quantity');

    controls.appendChild(minus);
    controls.appendChild(input);
    controls.appendChild(plus);
    group.appendChild(label);
    group.appendChild(controls);

    var note = createElement(
      'p',
      'wc-pdp-shipping-note',
      'Wine ships in multiples of three bottles. Choose any combination totalling 3, 6, 9 or more.'
    );

    actions.insertBefore(group, button);
    actions.insertBefore(note, button);
  }

  function productStatusNode(actions) {
    var existing = actions.querySelector('[data-wc-product-status]');
    if (existing) return existing;

    var status = createElement('p', 'wc-pdp-add-status');
    status.dataset.wcProductStatus = 'true';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    actions.appendChild(status);
    return status;
  }

  function productQuantity(button) {
    var actions = button.closest('.pdp-hero__actions');
    var input = actions ? actions.querySelector(PRODUCT_QUANTITY_SELECTOR) : null;
    var quantity = clampQuantity(input ? input.value : 1, 1);
    if (input) input.value = String(quantity);
    return quantity;
  }

  async function addProductQuantity(button) {
    if (button.dataset.wcAddPending === 'true') return;

    var variantId = parseInt(button.dataset.variantId, 10);
    if (!Number.isFinite(variantId)) return;

    var actions = button.closest('.pdp-hero__actions');
    if (!actions) return;

    var quantity = productQuantity(button);
    var status = productStatusNode(actions);
    var viewCart = actions.querySelector('#view-cart-btn, [data-wc-view-cart]');
    var originalLabel = button.dataset.wcOriginalLabel || button.textContent.trim() || 'Add to Cart';
    var wasDisabled = button.disabled;

    button.dataset.wcOriginalLabel = originalLabel;
    button.dataset.wcAddPending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    status.textContent = '';

    try {
      var response = await fetch(storeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: {
                _counts_as_wine_bottle: 'true'
              }
            }
          ]
        })
      });

      if (!response.ok) {
        var errorBody = await response.json().catch(function () {
          return {};
        });
        throw new Error(errorBody.description || errorBody.message || 'Unable to add this wine.');
      }

      await response.json();

      var cartResponse = await fetch(storeRoot() + 'cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      });
      var cart = cartResponse.ok ? await cartResponse.json() : null;

      button.textContent = 'Added to Cart';
      status.textContent =
        quantity === 1
          ? '1 bottle added to your cart.'
          : quantity + ' bottles added to your cart.';

      if (viewCart) {
        viewCart.hidden = false;
        viewCart.classList.remove('is-hidden');
        viewCart.classList.add('is-visible');
      }

      if (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            detail: {
              resource: cart,
              source: 'weathercraft-phase2-product'
            }
          })
        );
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      emit('wc_product_add_to_cart', {
        variant_id: String(variantId),
        quantity: quantity
      });
    } catch (error) {
      button.textContent = originalLabel;
      status.textContent = error && error.message ? error.message : 'Unable to add this wine.';
    } finally {
      button.dataset.wcAddPending = 'false';
      button.removeAttribute('aria-busy');
      button.disabled = wasDisabled;

      window.setTimeout(function () {
        if (button.dataset.wcAddPending !== 'true') button.textContent = originalLabel;
      }, 1600);
    }
  }

  function adjustProductQuantity(actionButton) {
    var group = actionButton.closest('[data-wc-pdp-quantity]');
    var input = group ? group.querySelector(PRODUCT_QUANTITY_SELECTOR) : null;
    if (!input) return;

    var quantity = clampQuantity(input.value, 1);
    quantity += actionButton.dataset.wcPdpQuantityAction === 'decrease' ? -1 : 1;
    input.value = String(clampQuantity(quantity, 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function cartQuantityInput(target) {
    return target instanceof HTMLInputElement && target.matches(CART_QUANTITY_SELECTOR)
      ? target
      : null;
  }

  function normaliseCartQuantity(input) {
    var minimum = parseInt(input.min, 10);
    if (!Number.isFinite(minimum)) minimum = 0;

    var fallback = parseInt(input.defaultValue, 10);
    if (!Number.isFinite(fallback)) fallback = Math.max(minimum, 1);

    var value = parseInt(input.value, 10);
    if (!Number.isFinite(value)) value = fallback;
    input.value = String(Math.max(minimum, value));
  }

  function handleCaptureKeydown(event) {
    var input = cartQuantityInput(event.target);
    if (!input || event.key !== 'Enter') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    normaliseCartQuantity(input);

    var component = input.closest('cart-quantity-selector-component');
    if (component) {
      component.dataset.wcQuantityCommitting = 'true';
      window.setTimeout(function () {
        component.removeAttribute('data-wc-quantity-committing');
      }, 900);
    }

    input.blur();
  }

  function handleCaptureBlur(event) {
    var input = cartQuantityInput(event.target);
    if (!input) return;
    normaliseCartQuantity(input);
  }

  function handleCaptureClick(event) {
    var quantityAction = event.target.closest('[data-wc-pdp-quantity-action]');
    if (quantityAction) {
      event.preventDefault();
      event.stopPropagation();
      adjustProductQuantity(quantityAction);
      return;
    }

    var cartStepper = event.target.closest('cart-quantity-selector-component button');
    if (cartStepper) {
      var cartComponent = cartStepper.closest('cart-quantity-selector-component');
      if (cartComponent && cartComponent.dataset.wcQuantityCommitting === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    var productButton = event.target.closest(PRODUCT_BUTTON_SELECTOR);
    if (!productButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addProductQuantity(productButton);
  }

  function fixEmptyCartLinks() {
    document.querySelectorAll('.cart-items__empty-button').forEach(function (link) {
      link.setAttribute('href', '/pages/wines');
    });
  }

  function replaceVisibleText(replacements) {
    if (!document.body) return;

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      var parentTag = node.parentElement ? node.parentElement.tagName : '';
      if (parentTag === 'SCRIPT' || parentTag === 'STYLE' || parentTag === 'NOSCRIPT') continue;

      replacements.forEach(function (replacement) {
        if (node.nodeValue.indexOf(replacement.from) !== -1) {
          node.nodeValue = node.nodeValue.split(replacement.from).join(replacement.to);
        }
      });
    }
  }

  function correctCopyAndSemantics() {
    replaceVisibleText([
      {
        from: 'Wines with provenance,made for considered lists.',
        to: 'Wines with provenance, made for considered lists.'
      },
      { from: 'provenance,made', to: 'provenance, made' },
      { from: 'VWinemaker', to: 'Winemaker' },
      {
        from: 'A structured chardonnay-complex, refined and quietly powerful.',
        to: 'A structured Chardonnay — complex, refined and quietly powerful.'
      }
    ]);

    document.querySelectorAll('img[alt*="Fenale"]').forEach(function (image) {
      image.alt = image.alt
        .replace('Fenale in the Vineyard', 'Raquel in the vineyard')
        .replace('tending to grape vines', 'tending grapevines');
    });

    if (window.location.pathname.replace(/\/$/, '') !== '/pages/welcome-to-weathercraft') return;

    document.querySelectorAll('h6').forEach(function (heading) {
      var text = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!/^(Fruit grown|Wine crafted|Bottled)/i.test(text)) return;

      var paragraph = document.createElement('p');
      paragraph.className = (heading.className + ' wc-estate-proof-label').trim();
      paragraph.innerHTML = heading.innerHTML;
      Array.from(heading.attributes).forEach(function (attribute) {
        if (attribute.name !== 'class') paragraph.setAttribute(attribute.name, attribute.value);
      });
      heading.replaceWith(paragraph);
    });
  }

  function upgradeDesktopSubmenuTriggers() {
    document
      .querySelectorAll('.wc-site-header__nav-item--has-submenu > a.wc-site-header__nav-link')
      .forEach(function (link, index) {
        if (link.getAttribute('href') !== '#') return;

        var parent = link.parentElement;
        var submenu = parent ? parent.querySelector('.wc-site-header__submenu') : null;
        if (!parent || !submenu) return;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = link.className + ' wc-site-header__nav-trigger';
        button.innerHTML = link.innerHTML;
        button.dataset.wcSubmenuTrigger = 'true';
        button.setAttribute('aria-haspopup', 'true');
        button.setAttribute('aria-expanded', 'false');

        if (!submenu.id) submenu.id = 'wc-desktop-submenu-' + index;
        button.setAttribute('aria-controls', submenu.id);
        link.replaceWith(button);
      });
  }

  function closeDesktopSubmenus(except) {
    document.querySelectorAll('.wc-site-header__nav-item.is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-wc-submenu-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function handleSubmenuClick(event) {
    var trigger = event.target.closest('[data-wc-submenu-trigger]');
    if (!trigger) {
      if (!event.target.closest('.wc-site-header__nav-item--has-submenu')) closeDesktopSubmenus();
      return;
    }

    event.preventDefault();
    var parent = trigger.closest('.wc-site-header__nav-item--has-submenu');
    if (!parent) return;

    var willOpen = !parent.classList.contains('is-open');
    closeDesktopSubmenus(parent);
    parent.classList.toggle('is-open', willOpen);
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function handleSubmenuKeydown(event) {
    if (event.key !== 'Escape') return;
    var openItem = event.target.closest('.wc-site-header__nav-item.is-open');
    if (!openItem) return;

    var trigger = openItem.querySelector('[data-wc-submenu-trigger]');
    openItem.classList.remove('is-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  function markPageContexts() {
    var path = window.location.pathname.replace(/\/$/, '');

    if (path === '/pages/welcome-to-weathercraft') {
      document.documentElement.classList.add('wc-qr-page');
    }

    if (path !== '/pages/wines') return;

    document.documentElement.classList.add('wc-wines-page');
    var heroSection = document.querySelector('.wc-page-hero')?.closest('.shopify-section');
    var catalogueSection = document.querySelector('.wc-catalogue')?.closest('.shopify-section');
    if (!heroSection || !catalogueSection) return;

    var section = heroSection.nextElementSibling;
    while (section && section !== catalogueSection) {
      if (section.classList.contains('shopify-section')) section.classList.add('wc-wines-prelude');
      section = section.nextElementSibling;
    }
  }

  function applyDynamicFixes() {
    ensureProductPurchaseControls();
    fixEmptyCartLinks();
    upgradeDesktopSubmenuTriggers();
    markPageContexts();
  }

  function scheduleDynamicFixes() {
    if (dynamicFixTimer) window.clearTimeout(dynamicFixTimer);
    dynamicFixTimer = window.setTimeout(applyDynamicFixes, 60);
  }

  document.addEventListener('click', handleCaptureClick, true);
  document.addEventListener('keydown', handleCaptureKeydown, true);
  document.addEventListener('blur', handleCaptureBlur, true);
  document.addEventListener('click', handleSubmenuClick);
  document.addEventListener('keydown', handleSubmenuKeydown);

  function initialise() {
    correctCopyAndSemantics();
    applyDynamicFixes();

    var observer = new MutationObserver(scheduleDynamicFixes);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
